import React, { useMemo } from 'react';

interface IListMenuProps {
    isShow: boolean;
    children?: React.ReactNode;
    onShowChange: (checked: boolean) => void;
}

const ListMenu = (props: IListMenuProps) => {
    const { isShow, children } = props;

    return <>{isShow && children ? children : null}</>;
};

export default ListMenu;
